import { createFileRoute } from "@tanstack/react-router";

import { StratifiedQueriesPage } from "@/features/stratified-queries/StratifiedQueriesPage";

export const Route = createFileRoute("/_authenticated/data/queries")({
  component: StratifiedQueriesPage,
});
